import { render, staticRenderFns } from "./MobileGame.vue?vue&type=template&id=fd7e079e&"
import script from "./MobileGame.vue?vue&type=script&lang=js&"
export * from "./MobileGame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports